import React, { PureComponent } from 'react';
import Pagination from '../../../commonModules/interface/Pagination';
import TabsContent from '../../../commonModules/interface/TabsContent';
import { Box, Tabs, Tab, AppBar, Card } from '@material-ui/core';
import { TabPanel } from '@material-ui/lab';

class ClientTab extends PureComponent {
    state = { }
    
    handleChange = (e, newHeader) => {
        console.log('====================================');
        console.log({newHeader});
        console.log('====================================');
        this.props.changeMenu(newHeader)
    }
    render() {
        // console.log('Content header : ', this.props.contentHeader, this.props.contentArray);
        // console.log('Page of items : ', this.state.pageOfItems);
        return (
            <Card>
                <AppBar position="static">
                    <Tabs
                        value={this.props.headerMenu}
                        onChange={this.handleChange}
                        indicatorColor="secondary"
                        // textColor="secondary"
                        variant="fullWidth"
                        scrollButtons="auto"
                    >
                        {/* <Tab label="Prospect" value="Prospect" />
                        <Tab label="Client à valider" value="Client" />
                        <Tab label="En attente de paiement" value="Payment" />
                        <Tab label="A payer" value="Payed" />
                        <Tab label="En attente d'installation" value="Installation" /> */}

                        <Tab label="Prospect" value="Prospect" />
                        <Tab label="Client à valider" value="WaitForValidation" />
                        <Tab label="En attente de paiement" value="WaitForPayment" />
                        <Tab label="A payer" value="HasPayed" />
                        <Tab label="En attente d'installation" value="WaitForInstallation" />

                    </Tabs>
                </AppBar>
                <Box p={2}>
                    {this.props.children}
                </Box>
            </Card>

        )
    }
}

export default ClientTab;